// import React, { useState } from 'react';
// import { Formik, Form } from 'formik';
// import * as Yup from 'yup';
// import { useTranslation } from 'react-i18next';

// const VenderDetails = ({ nextStep, prevStep }) => {
//   const { t } = useTranslation();
//   const [aadhaarFront, setAadhaarFront] = useState(null);
//   const [aadhaarBack, setAadhaarBack] = useState(null);

//   const initialValues = {
//     fullName: '',
//     mobile: '',
//     aadhaarNumber: '',
//     aadhaarFront: null,
//     aadhaarBack: null,
//   };

//   const validationSchema = Yup.object({
//     fullName: Yup.string().required(t('fullLegalName') + ' ' + t('isRequired')).min(3, t('minimumCharacters')),
//     mobile: Yup.string()
//       .required(t('mobileContactNumber') + ' ' + t('isRequired'))
//       .matches(/^[6-9]\d{9}$/, t('invalidMobile')),
//     aadhaarNumber: Yup.string()
//       .required(t('aadhaarCardNumber') + ' ' + t('isRequired'))
//       .matches(/^\d{4}\s?\d{4}\s?\d{4}$/, 'Enter valid 12-digit Aadhaar number'),
//     aadhaarFront: Yup.mixed()
//       .required(t('frontSideAadhaar') + ' ' + t('isRequired'))
//       .test('fileSize', t('fileTooLarge'), (value) => !value || value.size <= 5000000)
//       .test('fileType', t('invalidFileType'), (value) => !value || ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'].includes(value.type)),
//     aadhaarBack: Yup.mixed()
//       .required(t('backSideAadhaar') + ' ' + t('isRequired'))
//       .test('fileSize', t('fileTooLarge'), (value) => !value || value.size <= 5000000)
//       .test('fileType', t('invalidFileType'), (value) => !value || ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'].includes(value.type)),
//   });

//   const inputBaseClasses = 'w-full h-12 px-4 rounded-lg bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white placeholder:text-slate-400 transition-all outline-none';
//   const inputFocusClasses = 'focus:ring-2 focus:ring-primary/20 focus:border-primary';
//   const inputErrorClasses = 'border-red-500';
//   const inputNormalBorder = 'border border-slate-300 dark:border-slate-700';

//   return (
//     <>
//       <Formik
//         initialValues={initialValues}
//         validationSchema={validationSchema}
//         onSubmit={(values) => {
//           console.log('Vendor Details Submitted:', values);
//           nextStep();
//         }}
//       >
//         {({ values, touched, errors, setFieldValue, handleBlur }) => (
//           <Form className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-slate-200 dark:border-slate-800 p-6 md:p-8">
//             <div className="flex flex-col gap-8">
//               <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 flex gap-3 items-start">
//                 <span className="material-symbols-outlined text-primary mt-0.5">info</span>
//                 <div className="flex flex-col gap-1">
//                   <p className="text-xs font-bold font-medium text-slate-900 dark:text-slate-100">{t('identityVerificationRequired')}</p>
//                   <p className="text-xs font-bold text-slate-600 dark:text-slate-400">
//                     {t('provideOfficialId')}
//                   </p>
//                 </div>
//               </div>

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 <div className="flex flex-col gap-2">
//                   <label className="text-base font-medium text-slate-900 dark:text-slate-100">
//                     {t('fullLegalName')} <span className="text-red-800">*</span>
//                   </label>
//                   <input
//                     name="fullName"
//                     value={values.fullName}
//                     onChange={(e) => setFieldValue('fullName', e.target.value)}
//                     onBlur={handleBlur}
//                     className={`${inputBaseClasses} ${inputFocusClasses} ${touched.fullName && errors.fullName ? inputErrorClasses : inputNormalBorder}`}
//                     placeholder={t('fullLegalName')}
//                     type="text"
//                   />
//                   {touched.fullName && errors.fullName && <p className="text-red-800 text-xs font-bold ">{errors.fullName}</p>}
//                 </div>

//                 <div className="flex flex-col gap-2">
//                   <label className="text-base font-medium text-slate-900 dark:text-slate-100">
//                     {t('mobileContactNumber')} <span className="text-red-800">*</span>
//                   </label>
//                   <div className="relative">
//                     <span className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500 dark:text-slate-400 border-r border-slate-300 dark:border-slate-600 pr-3 mr-3">
//                       +91
//                     </span>
//                     <input
//                       name="mobile"
//                       value={values.mobile}
//                       onChange={(e) => setFieldValue('mobile', e.target.value.replace(/\D/g, '').slice(0, 10))}
//                       onBlur={handleBlur}
//                       className={`${inputBaseClasses} pl-16 pr-4 ${inputFocusClasses} ${touched.mobile && errors.mobile ? inputErrorClasses : inputNormalBorder}`}
//                       placeholder="98765 43210"
//                       type="tel"
//                     />
//                   </div>
//                   {touched.mobile && errors.mobile && <p className="text-red-800 text-xs font-bold ">{errors.mobile}</p>}
//                 </div>

//                 <div className="md:col-span-2 flex flex-col gap-2">
//                   <label className="text-base font-medium text-slate-900 dark:text-slate-100">
//                     {t('aadhaarCardNumber')} <span className="text-red-800">*</span>
//                   </label>
//                   <div className={`flex w-full items-center rounded-lg border overflow-hidden border-slate-300 dark:border-slate-700
//                      focus-within:ring-2 focus-within:ring-primary/20 focus-within:border-primary transition-all`}>
//                     <input
//                       name="aadhaarNumber"
//                       value={values.aadhaarNumber}
//                       onChange={(e) => {
//                         let val = e.target.value.replace(/\D/g, '').slice(0, 12);
//                         if (val.length > 8) val = val.replace(/(\d{4})(\d{4})(\d{4})/, '$1 $2 $3');
//                         else if (val.length > 4) val = val.replace(/(\d{4})(\d+)/, '$1 $2');
//                         setFieldValue('aadhaarNumber', val);
//                       }}
//                       onBlur={handleBlur}
//                       className={`${inputBaseClasses} pr-4 ${inputFocusClasses} ${touched.aadhaarNumber && errors.aadhaarNumber ? inputErrorClasses : inputNormalBorder}`}
//                       placeholder="XXXX XXXX XXXX"
//                       type="text"
//                     />
//                     <div className="px-4 text-slate-400 flex items-center gap-2 border-l border-slate-200 dark:border-slate-700 h-8 my-2">
//                       <span className="material-symbols-outlined text-[20px]">lock</span>
//                       <span className="text-xs font-bold font-medium hidden sm:block">256-bit Encrypted</span>
//                     </div>
//                   </div>
//                   {touched.aadhaarNumber && errors.aadhaarNumber && <p className="text-red-800 text-xs font-bold ">{errors.aadhaarNumber}</p>}
//                   <p className="text-xs font-bold text-slate-500 dark:text-slate-400">Enter your 12-digit Aadhaar number.</p>
//                 </div>
//               </div>

//               <div className="flex flex-col gap-6">
//                 <h4 className="text-base font-medium text-slate-900 dark:text-slate-100">
//                   {t('uploadIdentityProof')} <span className="text-red-800">*</span>
//                 </h4>

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                   <div className="flex flex-col gap-3">
//                     <span className="text-xs font-bold font-medium text-slate-700 dark:text-slate-300">{t('frontSideAadhaar')}</span>
//                     <div className="relative">
//                       <input
//                         type="file"
//                         accept="image/*,application/pdf"
//                         onChange={(e) => {
//                           const file = e.currentTarget.files?.[0];
//                           if (file) {
//                             setFieldValue('aadhaarFront', file);
//                             setAadhaarFront(file);
//                           }
//                         }}
//                         onBlur={handleBlur}
//                         className="absolute inset-0 opacity-0 cursor-pointer z-10"
//                       />
//                       <div className={`group relative flex flex-col items-center justify-center w-full h-56 border-2 ${
//                         touched.aadhaarFront && errors.aadhaarFront ? 'border-red-500' : 'border-dashed border-slate-300 dark:border-slate-600'
//                       } rounded-xl bg-slate-50 dark:bg-slate-800/50 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors cursor-pointer`}>
//                         {aadhaarFront ? (
//                           <div className="w-full h-full p-4 flex items-center justify-center">
//                             {aadhaarFront.type.startsWith('image/') ? (
//                               <img src={URL.createObjectURL(aadhaarFront)} alt="Aadhaar Front" className="max-w-full max-h-full object-contain rounded" />
//                             ) : (
//                               <div className="flex flex-col items-center gap-2">
//                                 <span className="material-symbols-outlined text-5xl text-primary">description</span>
//                                 <p className="text-xs font-bold text-slate-600 dark:text-slate-400">{aadhaarFront.name}</p>
//                               </div>
//                             )}
//                           </div>
//                         ) : (
//                           <>
//                             <div className="p-3 bg-primary/10 rounded-full text-primary">
//                               <span className="material-symbols-outlined text-3xl">cloud_upload</span>
//                             </div>
//                             <p className="text-xs font-bold font-medium text-slate-700 dark:text-slate-200">
//                               <span className="text-primary hover:underline">{t('clickToUpload')}</span> front side
//                             </p>
//                             <p className="text-xs font-bold text-slate-500 dark:text-slate-400">JPG, PNG or PDF (max 5MB)</p>
//                           </>
//                         )}
//                         <div className="absolute top-4 right-4 flex items-center gap-1.5 px-2.5 py-1 bg-green-50 dark:bg-green-900/30 border border-green-200 dark:border-green-800 rounded text-green-700 dark:text-green-400 text-xs font-bold font-medium">
//                           <span className="material-symbols-outlined text-[14px]">verified_user</span>
//                           {t('secureUpload')}
//                         </div>
//                       </div>
//                     </div>
//                     {touched.aadhaarFront && errors.aadhaarFront && <p className="text-red-800 text-xs font-bold ">{errors.aadhaarFront}</p>}
//                   </div>

//                   <div className="flex flex-col gap-3">
//                     <span className="text-xs font-bold font-medium text-slate-700 dark:text-slate-300">{t('backSideAadhaar')}</span>
//                     <div className="relative">
//                       <input
//                         type="file"
//                         accept="image/*,application/pdf"
//                         onChange={(e) => {
//                           const file = e.currentTarget.files?.[0];
//                           if (file) {
//                             setFieldValue('aadhaarBack', file);
//                             setAadhaarBack(file);
//                           }
//                         }}
//                         onBlur={handleBlur}
//                         className="absolute inset-0 opacity-0 cursor-pointer z-10"
//                       />
//                       <div className={`group relative flex flex-col items-center justify-center w-full h-56 border-2 ${
//                         touched.aadhaarBack && errors.aadhaarBack ? 'border-red-500' : 'border-dashed border-slate-300 dark:border-slate-600'
//                       } rounded-xl bg-slate-50 dark:bg-slate-800/50 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors cursor-pointer`}>
//                         {aadhaarBack ? (
//                           <div className="w-full h-full p-4 flex items-center justify-center">
//                             {aadhaarBack.type.startsWith('image/') ? (
//                               <img src={URL.createObjectURL(aadhaarBack)} alt="Aadhaar Back" className="max-w-full max-h-full object-contain rounded" />
//                             ) : (
//                               <div className="flex flex-col items-center gap-2">
//                                 <span className="material-symbols-outlined text-5xl text-primary">description</span>
//                                 <p className="text-xs font-bold text-slate-600 dark:text-slate-400">{aadhaarBack.name}</p>
//                               </div>
//                             )}
//                           </div>
//                         ) : (
//                           <>
//                             <div className="p-3 bg-primary/10 rounded-full text-primary">
//                               <span className="material-symbols-outlined text-3xl">cloud_upload</span>
//                             </div>
//                             <p className="text-xs font-bold font-medium text-slate-700 dark:text-slate-200">
//                               <span className="text-primary hover:underline">{t('clickToUpload')}</span> back side
//                             </p>
//                             <p className="text-xs font-bold text-slate-500 dark:text-slate-400">JPG, PNG or PDF (max 5MB)</p>
//                           </>
//                         )}
//                         <div className="absolute top-4 right-4 flex items-center gap-1.5 px-2.5 py-1 bg-green-50 dark:bg-green-900/30 border border-green-200 dark:border-green-800 rounded text-green-700 dark:text-green-400 text-xs font-bold font-medium">
//                           <span className="material-symbols-outlined text-[14px]">verified_user</span>
//                           {t('secureUpload')}
//                         </div>
//                       </div>
//                     </div>
//                     {touched.aadhaarBack && errors.aadhaarBack && <p className="text-red-800 text-xs font-bold mt-9541">{errors.aadhaarBack}</p>}
//                   </div>
//                 </div>

//                 <div className="flex items-center justify-center gap-4 mt-4">
//                   <span className="h-px w-20 bg-slate-300 dark:bg-slate-600" />
//                   <span className="text-xs font-bold text-slate-400 uppercase">{t('or')}</span>
//                   <span className="h-px w-20 bg-slate-300 dark:bg-slate-600" />
//                 </div>

//                 <div className="flex justify-center">
//                   <button
//                     type="button"
//                     className="flex items-center gap-2 px-6 py-3 text-xs font-bold font-medium text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-lg shadow-sm hover:bg-slate-50 dark:hover:bg-slate-600 transition-all"
//                   >
//                     <span className="material-symbols-outlined text-[24px]">photo_camera</span>
//                     {t('captureFromCamera')}
//                   </button>
//                 </div>
//               </div>

//               <div className="flex flex-col-reverse sm:flex-row items-center justify-between gap-4 pt-4 border-t border-slate-100 dark:border-slate-800">
//                 <button
//                   type="button"
//                   onClick={prevStep}
//                   className="w-full sm:w-auto px-6 py-3 rounded-lg border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-200 font-medium hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors"
//                 >
//                   {t('back')}
//                 </button>
//                 <button
//                   type="submit"
//                   className="w-full sm:w-auto flex items-center justify-center gap-2 px-8 py-3 rounded-lg bg-primary text-white font-medium hover:bg-primary/90 shadow-sm shadow-primary/20 transition-all"
//                 >
//                   {t('saveAndContinue')}
//                   <span className="material-symbols-outlined text-[20px]">arrow_forward</span>
//                 </button>
//               </div>
//             </div>
//           </Form>
//         )}
//       </Formik>
//     </>
//   );
// };

// export default VenderDetails;
import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useAminitiesData, useUserShopDetailsData } from "../../API_Master/GetAPI";
import { useAddVenderDetails } from "../../API_Master/MutateAPI";
import Cookies from "js-cookie";
import { notifyError } from "../../HelperMethods";
import { NIGHT_EYE_IMG_URL } from "../../Process";
import FormLanguageSync from "../FormLanguageSync";
import AdharUpload from "./AdharUpl;oad";
import FullScreenLoader from "../FullScreenLoader";
const VenderDetails = ({ nextStep, prevStep, shopDetailsData }) => {
  const { t } = useTranslation();
  console.log(shopDetailsData, "shopDetailsDatashopDetailsData");
  const { data: aminities = [] } = useAminitiesData();
  const { data: userShopData = [] } = useUserShopDetailsData(null, Cookies.get("VENDER_NIGHT_EYE_USER_ID"));
  const isMultipleShopAvailble = userShopData?.length > 1;
  const { mutate: addVenderDetails, isPending: addingVenderDetails } = useAddVenderDetails();

  const validationSchema = Yup.object({
    fullName: Yup.string()
      .required(t("fullLegalName") + " " + t("isRequired"))
      .min(3, t("minimumCharacters"))
      .matches(/^[a-zA-Z\s]+$/, "Name should contain only letters and spaces"),
    // mobile: Yup.string()
    //   .required(t('mobileContactNumber') + ' ' + t('isRequired'))
    //   .matches(/^[6-9]\d{9}$/, t('invalidMobile')),
    aadhaarNumber: Yup.string()
      .required(t("aadhaarCardNumber") + " " + t("isRequired"))
      .matches(/^\d{4}\s?\d{4}\s?\d{4}$/, "Enter valid 12-digit Aadhaar number"),
    aadhaarFront: Yup.mixed().when("oldAdharFronImage", {
      is: (oldAdharFronImage) => !oldAdharFronImage || oldAdharFronImage.trim() === "",
      then: (schema) =>
        schema
          .required(t("frontSideAadhaar") + " " + t("isRequired"))
          .test("fileSize", t("fileTooLarge"), (value) => !value || value.size <= 5000000)
          .test("fileType", t("invalidFileType"), (value) => !value || ["image/jpeg", "image/jpg", "image/png", "application/pdf"].includes(value.type)),
      otherwise: (schema) =>
        schema
          .nullable()
          .notRequired()
          .test("fileSize", t("fileTooLarge"), (value) => !value || value.size <= 5000000)
          .test("fileType", t("invalidFileType"), (value) => !value || ["image/jpeg", "image/jpg", "image/png", "application/pdf"].includes(value.type)),
    }),
    aadhaarBack: Yup.mixed()
      .nullable()
      .test("fileSize", t("fileTooLarge"), (value) => !value || value.size <= 5000000)
      .test("fileType", t("invalidFileType"), (value) => !value || ["image/jpeg", "image/jpg", "image/png", "application/pdf"].includes(value.type)),
    selectedAmenities: Yup?.array()
      .of(
        Yup?.object({
          AmenitiesID: Yup.string().required(),
          // AmenitiesSubTypeID: Yup.string().required('Please select a sub-type'),
        }),
      )
      .min(1, "Please select at least one amenity with its status"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    const payload = {
      UserID: Cookies.get("VENDER_NIGHT_EYE_USER_ID") || "",
      ShopDetailID: Cookies.get("NIGHT_EYE_SHOP_DETAIL_ID") || "",
      ShopUserName: values.fullName || "",
      AadhaarCardNumber: values.aadhaarNumber || "",
      AadhaarCardImage: values?.aadhaarFront || "",

      CreatedByUserID: Cookies.get("NIGHT_EYE_USER_ID") || "",
      OldAadhaarCardImage: values?.oldAdharFronImage || "",
      // Helper details as JSON string (same as backend expects from formData)
      AmenitiesDetail: JSON.stringify(
        aminities?.map((ele) => {
          const isAminityAvailable = values?.selectedAmenities?.filter((ele2) => ele2.AmenitiesID == ele.AmenitiesID);
          if (isAminityAvailable?.length) {
            return {
              AmenitiesID: isAminityAvailable?.[0]?.AmenitiesID,
              IsAvailable: "true",
              AmenitiesSubTypeID: isAminityAvailable?.[0]?.AmenitiesSubTypeID,
            };
          } else {
            return {
              AmenitiesID: ele?.AmenitiesID,
              IsAvailable: "false",
              AmenitiesSubTypeID: null,
            };
          }
        }),
      ),
    };
    addVenderDetails(payload, {
      onSuccess: (res) => {
        if (res?.status === true) {
          Cookies.set("IsStep2Completed", true);
          nextStep();
        } else {
          notifyError(res?.message || "Data Not Inserted");
        }
      },
      onError: (err) => {
        notifyError("Failed to Insert User");
      },
    });
  };

  const inputBaseClasses = "w-full h-12 px-4 rounded-lg bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white placeholder:text-slate-400 transition-all outline-none";
  const inputFocusClasses = "focus:ring-2 focus:ring-primary/20 focus:border-primary";
  const inputErrorClasses = "border-red-500";
  const inputNormalBorder = "border border-slate-300 dark:border-slate-700";

  return (
    <>
      <Formik
        initialValues={{
          fullName: shopDetailsData?.[0]?.ShopUserDetail?.[0].ShopUserName || "",
          mobile: shopDetailsData?.[0]?.ShopUserDetail?.[0].ShopUserMobileNo || "",
          aadhaarNumber: shopDetailsData?.[0]?.ShopUserDetail?.[0].AadhaarCardNo || "",
          aadhaarFront: null,
          oldAdharFronImage: shopDetailsData?.[0]?.ShopUserDetail?.[0].AadhaarCardImage || "",
          aadhaarBack: null,
          selectedAmenities:
            shopDetailsData?.[0]?.ShopAmenitiesDetail?.filter((ele) => ele.IsAvailable)?.map((ele) => {
              return {
                AmenitiesID: ele?.AmenitiesID,
                AmenitiesSubTypeID: ele?.ShopAmenitiesSubDetail?.[0]?.AmenitiesSubTypeID,
                // , ShopAmenitiesDetailID: ele?.ShopAmenitiesDetailID
              };
            }) || [],
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        // enableReinitialize={true}  // ← THIS IS THE KEY FIX
      >
        {({ values, touched, errors, setFieldValue, handleBlur, isSubmitting }) => (
          <>
            {" "}
            <FormLanguageSync />
            <Form className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-slate-200 dark:border-slate-800 p-6 md:p-8">
              <div className="flex flex-col gap-8">
                {/* Info Banner */}
                <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 flex gap-3 items-start">
                  <span className="material-symbols-outlined text-primary mt-0.5">info</span>
                  <div className="flex flex-col gap-1">
                    <p className="text-xs font-bold font-medium text-slate-900 dark:text-slate-100">{t("identityVerificationRequired")}</p>
                    <p className="text-xs font-bold text-slate-600 dark:text-slate-400">{t("provideOfficialId")}</p>
                  </div>
                </div>

                {/* Personal Details */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="flex flex-col gap-2">
                    <label className="text-base font-medium text-slate-900 dark:text-slate-100">
                      {t("fullLegalName")} <span className="text-red-800">*</span>
                    </label>
                    <input
                      name="fullName"
                      value={values.fullName}
                      disabled={isMultipleShopAvailble && values.fullName ? true : false}
                      onChange={(e) => setFieldValue("fullName", e.target.value)}
                      onBlur={handleBlur}
                      className={`${inputBaseClasses} ${inputFocusClasses} ${touched.fullName && errors.fullName ? inputErrorClasses : inputNormalBorder}`}
                      placeholder={t("fullLegalName")}
                      type="text"
                    />
                    {touched.fullName && errors.fullName && <p className="text-red-800 text-xs font-bold">{errors.fullName}</p>}
                  </div>

                  <div className="flex flex-col gap-2">
                    <label className="text-base font-medium text-slate-900 dark:text-slate-100">
                      {t("mobileContactNumber")} <span className="text-red-800">*</span>
                    </label>
                    <div className="relative">
                      <span className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500 dark:text-slate-400 border-r border-slate-300 dark:border-slate-600 pr-3 mr-3">
                        +91
                      </span>
                      <input
                        name="mobile"
                        value={values.mobile}
                        onChange={(e) => setFieldValue("mobile", e.target.value.replace(/\D/g, "").slice(0, 10))}
                        onBlur={handleBlur}
                        disabled={!!values.mobile}
                        className={`${inputBaseClasses} pl-16 pr-4 ${inputFocusClasses} ${touched.mobile && errors.mobile ? inputErrorClasses : inputNormalBorder}`}
                        placeholder="98765 43210"
                        type="tel"
                      />
                    </div>
                    {touched.mobile && errors.mobile && <p className="text-red-800 text-xs font-bold">{errors.mobile}</p>}
                  </div>

                  <div className="md:col-span-2 flex flex-col gap-2">
                    <label className="text-base font-medium text-slate-900 dark:text-slate-100">
                      {t("aadhaarCardNumber")} <span className="text-red-800">*</span>
                    </label>
                    <div
                      className={`flex w-full items-center rounded-lg border overflow-hidden ${touched.aadhaarNumber && errors.aadhaarNumber ? "border-red-500" : "border-slate-300 dark:border-slate-700"} focus-within:ring-2 focus-within:ring-primary/20 focus-within:border-primary transition-all`}
                    >
                      <input
                        name="aadhaarNumber"
                        value={values.aadhaarNumber}
                        disabled={isMultipleShopAvailble && values.aadhaarNumber ? true : false}
                        onChange={(e) => {
                          let val = e.target.value.replace(/\D/g, "").slice(0, 12);
                          if (val.length > 8) val = `${val.slice(0, 4)} ${val.slice(4, 8)} ${val.slice(8)}`;
                          else if (val.length > 4) val = `${val.slice(0, 4)} ${val.slice(4)}`;
                          setFieldValue("aadhaarNumber", val);
                          // Store clean version for submission
                          setFieldValue("aadhaarNumberClean", val.replace(/\s/g, ""));
                        }}
                        onBlur={handleBlur}
                        className={`${inputBaseClasses} ${inputFocusClasses}`}
                        placeholder="XXXX XXXX XXXX"
                        type="text"
                      />
                      <div className="px-4 text-slate-400 flex items-center gap-2 border-l border-slate-200 dark:border-slate-700 h-8 my-2">
                        <span className="material-symbols-outlined text-[20px]">lock</span>
                        <span className="text-xs font-bold font-medium hidden sm:block">256-bit Encrypted</span>
                      </div>
                    </div>
                    {touched.aadhaarNumber && errors.aadhaarNumber && <p className="text-red-800 text-xs font-bold">{errors.aadhaarNumber}</p>}
                  </div>
                </div>

                {/* Aadhaar Upload */}
                <div className="flex flex-col gap-6">
                  <h4 className="text-base font-medium text-slate-900 dark:text-slate-100">
                    {t("uploadIdentityProof")} <span className="text-red-800">*</span>
                  </h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Front Side */}
                    <div className="flex flex-col gap-3">
                      <AdharUpload isMultipleShopAvailble={isMultipleShopAvailble} />
                    </div>

                    {/* Back Side (Optional) */}
                    {/* <div className="flex flex-col gap-3">
                  <span className="text-xs font-bold font-medium text-slate-700 dark:text-slate-300">
                    {t('backSideAadhaar')} (Optional)
                  </span>
                  <div className="relative">
                    <input
                      type="file"
                      accept="image/*,application/pdf"
                      onChange={(e) => {
                        const file = e.currentTarget.files?.[0];
                        if (file) {
                          setFieldValue('aadhaarBack', file);
                          setAadhaarBack(file);
                        }
                      }}
                      className="absolute inset-0 opacity-0 cursor-pointer z-10"
                    />
                    <div className={`group relative flex flex-col items-center justify-center w-full h-56 border-2 ${touched.aadhaarBack && errors.aadhaarBack ? 'border-red-500' : 'border-dashed border-slate-300 dark:border-slate-600'} rounded-xl bg-slate-50 dark:bg-slate-800/50 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors cursor-pointer`}>
                      {aadhaarBack ? (
                        <div className="w-full h-full p-4 flex items-center justify-center">
                          {aadhaarBack.type.startsWith('image/') ? (
                            <img src={URL.createObjectURL(aadhaarBack)} alt="Back" className="max-w-full max-h-full object-contain rounded" />
                          ) : (
                            <div className="flex flex-col items-center gap-2">
                              <span className="material-symbols-outlined text-5xl text-primary">description</span>
                              <p className="text-xs font-bold text-slate-600 dark:text-slate-400">{aadhaarBack.name}</p>
                            </div>
                          )}
                        </div>
                      ) : (
                        <>
                          <div className="p-3 bg-primary/10 rounded-full text-primary">
                            <span className="material-symbols-outlined text-3xl">cloud_upload</span>
                          </div>
                          <p className="text-xs font-bold font-medium text-slate-700 dark:text-slate-200">
                            <span className="text-primary hover:underline">{t('clickToUpload')}</span> back side
                          </p>
                          <p className="text-xs font-bold text-slate-500 dark:text-slate-400">JPG, PNG or PDF (max 5MB)</p>
                        </>
                      )}
                      <div className="absolute top-4 right-4 flex items-center gap-1.5 px-2.5 py-1 bg-green-50 dark:bg-green-900/30 border border-green-200 dark:border-green-800 rounded text-green-700 dark:text-green-400 text-xs font-bold font-medium">
                        <span className="material-symbols-outlined text-[14px]">verified_user</span>
                        {t('secureUpload')}
                      </div>
                    </div>
                  </div>
                  {touched.aadhaarBack && errors.aadhaarBack && (
                    <p className="text-red-800 text-xs font-bold">{errors.aadhaarBack}</p>
                  )}
                </div> */}
                  </div>
                </div>

                {/* Amenities Section */}
                <div className="flex flex-col gap-6">
                  <h4 className="text-base font-medium text-slate-900 dark:text-slate-100">
                    {t("shopAminities")}
                    <span className="text-red-800">*</span>
                  </h4>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 ">
                    {aminities.map((amenity) => {
                      const isSelected = values?.selectedAmenities?.some((item) => item.AmenitiesID == amenity.AmenitiesID);
                      const selectedSubType = values?.selectedAmenities?.find((item) => item.AmenitiesID == amenity.AmenitiesID)?.AmenitiesSubTypeID;

                      return (
                        <div key={amenity.AmenitiesID} className="p-4 border border-slate-200 dark:border-slate-700 rounded-lg bg-slate-50 dark:bg-slate-800/50">
                          <label className="flex items-center gap-3 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={isSelected}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  // Auto-select first sub-type when checking
                                  const firstSub = amenity.AmenitiesSubType[0];
                                  setFieldValue("selectedAmenities", [
                                    ...values.selectedAmenities,
                                    {
                                      AmenitiesID: amenity.AmenitiesID,
                                      AmenitiesSubTypeID: firstSub.AmenitiesSubTypeID,
                                    },
                                  ]);
                                } else {
                                  setFieldValue(
                                    "selectedAmenities",
                                    values.selectedAmenities.filter((item) => item.AmenitiesID != amenity.AmenitiesID),
                                  );
                                }
                              }}
                              className="w-5 h-5 text-primary rounded border-slate-300"
                            />
                            <span className="font-medium text-slate-800 dark:text-slate-200">{amenity.AmenitiesName}</span>
                          </label>

                          {/* Show sub-types only if amenity is selected */}
                          {isSelected && amenity.AmenitiesSubType.length > 0 && (
                            <div className="mt-4 ml-8 space-y-2">
                              <p className="text-sm font-medium text-slate-600 dark:text-slate-400">Status:</p>
                              {amenity?.AmenitiesSubType?.map((sub) => (
                                <label key={sub?.AmenitiesSubTypeID} className="flex items-center gap-2 cursor-pointer">
                                  <input
                                    type="radio"
                                    name={`subType_${amenity.AmenitiesID}`}
                                    checked={selectedSubType == sub.AmenitiesSubTypeID}
                                    onChange={() => {
                                      setFieldValue(
                                        "selectedAmenities",
                                        values.selectedAmenities.map((item) =>
                                          item.AmenitiesID == amenity.AmenitiesID ? { ...item, AmenitiesSubTypeID: sub.AmenitiesSubTypeID } : item,
                                        ),
                                      );
                                    }}
                                    className="text-primary"
                                  />
                                  <span className="text-sm text-slate-700 dark:text-slate-300">{sub.AmenitiesSubTypeName}</span>
                                </label>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>

                  {touched.selectedAmenities && errors.selectedAmenities && <p className="text-red-800 text-xs font-bold">{errors.selectedAmenities}</p>}
                </div>

                {/* Buttons */}
                <div className="flex flex-col-reverse sm:flex-row items-center justify-between gap-4 pt-6 border-t border-slate-100 dark:border-slate-800">
                  <button
                    type="button"
                    onClick={prevStep}
                    className="w-full sm:w-auto px-6 py-3 rounded-lg border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-200 font-medium hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors"
                  >
                    {t("back")}
                  </button>
                  <button
                    type="submit"
                    disabled={addingVenderDetails}
                    className="w-full sm:w-auto flex items-center justify-center gap-2 px-8 py-3 rounded-lg bg-primary text-white font-medium hover:bg-primary/90 shadow-sm shadow-primary/20 transition-all disabled:opacity-70 disabled:cursor-not-allowed"
                  >
                    {t("saveAndContinue")}
                    <span className="material-symbols-outlined text-[20px]">arrow_forward</span>
                  </button>
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
      {addingVenderDetails && <FullScreenLoader />}
    </>
  );
};

export default VenderDetails;
